import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function BreakPeriod() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            BREAK PERIOD
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('schedule.break.title')}
          </h2>
          {String(t('schedule.break.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('schedule.break.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto mt-5">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <Link
            to="/seminar"
            className="card-glow group block bg-background-50 border border-background-200/60 p-6 cursor-pointer text-center"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-accent-500/10 rounded-full mx-auto mb-4 group-hover:bg-accent-500/20 transition-colors">
              <i className="ri-lightbulb-line text-accent-600 text-lg"></i>
            </div>
            <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] mb-2 group-hover:text-accent-600 transition-colors">
              {t('schedule.break.seminar.title')}
            </h3>
            {String(t('schedule.break.seminar.desc')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-3">{__s}</p>))}
            <span className="text-[13px] text-accent-500 tracking-[0.06em] group-hover:text-accent-400 transition-colors">
              {t('schedule.break.seminar.link')}
            </span>
          </Link>

          <Link
            to="/corporate"
            className="card-glow group block bg-background-50 border border-background-200/60 p-6 cursor-pointer text-center"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-accent-500/10 rounded-full mx-auto mb-4 group-hover:bg-accent-500/20 transition-colors">
              <i className="ri-building-2-line text-accent-600 text-lg"></i>
            </div>
            <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] mb-2 group-hover:text-accent-600 transition-colors">
              {t('schedule.break.corporate.title')}
            </h3>
            {String(t('schedule.break.corporate.desc')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-3">{__s}</p>))}
            <span className="text-[13px] text-accent-500 tracking-[0.06em] group-hover:text-accent-400 transition-colors">
              {t('schedule.break.corporate.link')}
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
